// extracted by mini-css-extract-plugin
export default {"themeToggle":"ThemeToggle_themeToggle__oP0ja","circle":"ThemeToggle_circle__0my6J","light":"ThemeToggle_light__AlzVf","dark":"ThemeToggle_dark__qz4OV"};